import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgChatFilled = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      clipRule="evenodd"
      d="M2.428 4.464A5 5 0 0 1 5.963 3h13.334a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5h-2.253l-3.707 3.707a1 1 0 0 1-1.414 0L8.216 21H5.963a5 5 0 0 1-5-5V8a5 5 0 0 1 1.465-3.536m3.869 4.868a1 1 0 0 1 1-1h10.666a1 1 0 1 1 0 2H7.297a1 1 0 0 1-1-1m2.333 4.332a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgChatFilled);
export default Memo;
